import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { StripeTaxRate, TaxRatesListResponse } from "./types";

export const CATALOG_TAX_RATES_QUERY_KEY = ["admin", "catalog", "tax-rates"] as const;

async function fetchTaxRates(): Promise<readonly StripeTaxRate[]> {
  const res = await httpClient<TaxRatesListResponse>("/api/admin/catalog/tax-rates");
  return res.items;
}

export function useTaxRatesList() {
  return useQuery({
    queryKey: CATALOG_TAX_RATES_QUERY_KEY,
    queryFn: fetchTaxRates,
    staleTime: 60_000,
  });
}
